import React, {useState,useEffect} from 'react';
import MainDropDown from '../../partials/MainDropDown/MainDropDown.js'

const CapabilitiesPopUp = props =>{
        // props:
	// data, see below
	// scrim:false turns scrim off. can also be in data
	// centered:false turns off auto centering of popup-body
	// style is style json that gets applied to popup-body
	// instant:true turns off cleanup phase and intro animations


	const [cleanup, setCleanup] = useState(false)

	const data = props.data || {
		scrim:true,
		header:'Error',
		body:"Popup data prop not provided",
		button:"button"
	}

	const handleButtonClick = () => {
		setCleanup(true);
        setTimeout(()=> {
			if(props.onClose) props.onClose();
			if(props.onComplete) props.onComplete();
		}, (props.instant === true ? 0 : 600));
	}

	const getAnimationClasses = () => {
		if(props.instant === true) return '';
		return cleanup ? 'cleanup' : 'not-cleanup'
	}

	return (
		<div className={`Popup ${getAnimationClasses()} ${props.class || ''} ${props.centered === false ? 'not-centered' : 'centered'} `}>
			<div className="popup-body" style={props.style || {backgroundColor: "#283044", }}>
                <div onClick={handleButtonClick} style={{position: "absolute", right: "10px", top:"10px", color:"white"}}>X</div>
                <div style={{overflowY: "scroll", overflowX:"hidden", height:"535px",width:"650px"}}>
                    {
                        props.data.capabilities.map((e,i) => {
                            return <MainDropDown data={e} index={i} clickedCheckboxes={props.clickedCheckboxes} checked={props.clickedCheckboxes[i][0]} showAudio={()=>console.log("audio")} />
                        })
                    }
                </div>		
                </div>
		</div>
	)
}

export default CapabilitiesPopUp;